import React from "react";
import styles from "./styles.css";
function Main({ children }) {
    return (React.createElement("main", { className: styles.wideContainer },
        React.createElement("div", { className: styles.container }, children)));
}
export default Main;
